import { _PdfDecodeStream } from './decode-stream';
export class _PdfDecryptStream extends _PdfDecodeStream {
    constructor(stream, maybeLength, cipher) {
        super(maybeLength);
        this._chunkSize = 512;
        this.stream = stream;
        this.dictionary = stream.dictionary;
        this._cipher = cipher;
        this._nextChunk = null;
        this._initialized = false;
    }
    readBlock() {
        let chunk;
        if (this._initialized) {
            chunk = this._nextChunk;
        }
        else {
            chunk = this.stream.getBytes(this._chunkSize);
            this._initialized = true;
        }
        if (!chunk || chunk.length === 0) {
            this.eof = true;
            return;
        }
        this._nextChunk = this.stream.getBytes(this._chunkSize);
        const hasMoreData = this._nextChunk && this._nextChunk.length > 0;
        chunk = this._cipher._decryptBlock(chunk, !hasMoreData);
        const n = chunk.length;
        const buffer = this.ensureBuffer(this.bufferLength + n);
        buffer.set(chunk, this.bufferLength);
        this.bufferLength += n;
    }
}
